<template>
  <div class="rounded-full bg-white" style="width: 22px; height: 22px;">
    <div class="relative w-full h-full flex items-center justify-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
        <circle cx="3" cy="3" r="3" :fill="color" />
      </svg>
      <BaseLoadingSpinnerCircle class="spinner-circle" :style="{ color: color }"
      :duration="0.8" :width="28" :height="28" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PointLoadingIndicator',
  props: {
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>

<style scoped>
.spinner-circle {
  position: absolute;
  top: -3px;
  left: -3px;
}
</style>